module.exports = __webpack_public_path__ + "static/media/testing-targeted-precision.93087764.png";